import { useEffect } from 'react';
import { useAdminStore } from '../store/adminStore';

export default function AuditToast() {
  const text = useAdminStore((state) => state.auditToast);
  const clear = useAdminStore((state) => state.clearAuditToast);

  useEffect(() => {
    if (!text) return undefined;
    const timer = setTimeout(() => clear(), 3000);
    return () => clearTimeout(timer);
  }, [text, clear]);

  if (!text) return null;
  return <div className="wb-audit-toast">{text}</div>;
}
